const stylesMap = {
    NEGATIVE: 'sh-neg',
    POSITIVE: 'sh-pos',
    BOLD: 'sh-bold',
    SUPERSCRIPT: 'sh-superscript',
    SUBSCRIPT: 'sh-subscript',
    STRIKETHROUGH: 'sh-strikethrough',
    EMPHASIS: 'sh-emphasis',
    HIGHLIGHT: 'sh-highlight',
    ITALIC: 'sh-italic',
    DEFAULT: 'sh-default'
};
const iconNameMap = {
    ARROW_DOWN: 'arrow-down',
    ARROW_UP: 'arrow-up',
    NEGATIVE: 'arrow-down',
    POSITIVE: 'arrow-up'
};

function checkArray(arg) {
    if (!Array.isArray(arg)) {
        throw Error('Styles must be passed as an array');
    }
}

module.exports = {
    applyStyles: function applyStyles(xsStyles) {
        let i;
        let len;
        const newStyles = [];

        if (xsStyles) {
            checkArray(xsStyles);

            for (i = 0, len = xsStyles.length; i < len; i += 1) {
                newStyles.push(stylesMap[xsStyles[i]]);
            }
        }

        return newStyles;
    },

    getIconName: function getIconName(xsStyles) {
        let iconName = '';
        let j;
        const keys = Object.keys(iconNameMap);

        if (xsStyles) {
            checkArray(xsStyles);

            for (j = 0; j < keys.length; j += 1) {
                if (xsStyles.indexOf(keys[j]) > -1) {
                    iconName = iconNameMap[keys[j]];
                    break;
                }
            }
        }

        return iconName;
    }
};
